import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { tr, lbl } from "../lib/i18n";

export function CustomerLeads({ customerId }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/leads", { params: { customer_id: customerId } }).then((r) => setItems(r.data.items)).catch(() => setItems([])); }, [customerId]);
  if (!items) return null;
  return (
    <section className="border border-[var(--divider)] p-4" data-testid="customer-leads">
      <h2 className="font-semibold mb-2">{tr("ld.title")} ({items.length})</h2>
      {!items.length && <div className="text-sm opacity-60">{tr("ld.empty")}</div>}
      <ul className="space-y-1 text-sm">
        {items.map((l) => (
          <li key={l.id}><Link to={`/leads/${l.id}`} className="underline" data-testid={`customer-lead-${l.id}`}>{l.vehicle_label || tr("ld.no_car")}</Link>
            {" · "}{lbl(l.stage || "New")} · {lbl(l.source)} · {l.assigned_name || tr("ld.unassigned")}</li>
        ))}
      </ul>
    </section>
  );
}
